<template>
  <div class="pdf-outline-sidebar">
    <div class="pdf-outline-sidebar__header">
      Table of Contents
    </div>

    <div class="pdf-outline-sidebar__list">
      <PDFOutlineItem
        v-for="(item, index) in outline"
        :key="index"
        :item="item"
        :current-page="currentPage"
        :level="0"
        @select="emit('select', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { PDFOutlineItem as OutlineItemType } from '../types'
import PDFOutlineItem from './PDFOutlineItem.vue'

defineProps({
  outline: {
    type: Array as PropType<OutlineItemType[]>,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
})

const emit = defineEmits<{
  select: [page: number]
}>()
</script>

<style lang="scss" scoped>
@use '@/styles/design-tokens' as *;

.pdf-outline-sidebar {
  width: 280px;
  background: rgb(var(--v-theme-surface));
  border-right: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__header {
    padding: $space-md $space-lg;
    font-size: $text-base;
    font-weight: $font-medium;
    border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  }

  &__list {
    flex: 1;
    overflow-y: auto;
    padding: $space-sm 0;
  }
}
</style>
